var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppleNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1227 16.8524C25.0787 16.8524 21.9147 14.5284 18.5827 14.6124C14.1867 14.6684 10.1547 17.1604 7.88669 21.1084C3.32269 29.0324 6.71069 40.7364 11.1627 47.1764C13.3467 50.3124 15.9227 53.8404 19.3387 53.7284C22.6147 53.5884 23.8467 51.6004 27.8227 51.6004C31.7707 51.6004 32.8907 53.7284 36.3627 53.6444C39.8907 53.5884 42.1307 50.4524 44.2867 47.2884C46.7787 43.6484 47.8147 40.1204 47.8707 39.9244C47.7867 39.8964 41.0107 37.2924 40.9267 29.4524C40.8707 22.9004 46.2747 19.7644 46.5267 19.6244C43.4467 15.1164 38.7147 14.6124 37.0627 14.5004C32.7507 14.1644 29.1387 16.8524 27.1227 16.8524ZM34.4027 10.2444C36.2227 8.06038 37.4267 5.00838 37.0907 1.98438C34.4867 2.09638 31.3507 3.72038 29.4747 5.90438C27.7947 7.83638 26.3387 10.9444 26.7307 13.9124C29.6147 14.1364 32.5827 12.4284 34.4027 10.2444Z",
    fill: "#090110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppleNew);
export default __webpack_public_path__ + "static/media/icon_apple_new.59fc41050f602573d1f4350234b13020.svg";
export { ForwardRef as ReactComponent };